import React from 'react'
import { Link } from 'react-router-dom'

const Smallnav = () => {
    return (
        <>
            <section
                id="smallscreen-navigation-six"
                className="smallscreen-navigation-six-main-block"
            >
                <div className="container-fluid">
                    <div
                        className="offcanvas offcanvas-start"
                        id="offcanvasNavbar"
                        aria-labelledby="offcanvasNavbarLabel"
                    >
                        <div className="offcanvas-header">
                            <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                                Menu
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                            />
                        </div>
                        <div className="offcanvas-body">
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                <li className="nav-item dropdown">
                                    <Link
                                        className="nav-link dropdown-toggle active"
                                        to="#"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        aria-current="page"
                                    >
                                        Home <i className="flaticon-down-arrow" />
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <Link className="dropdown-item" to="/">
                                                Home Page 01
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Hometwo">
                                                Home Page 02
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Homethree">
                                                Home Page 03
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Homefour">
                                                Home Page 04
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/HomeFive">
                                                Home Page 05
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item active" to="/HomeSix">
                                                Home Page 06
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Homeseven">
                                                Home Page 07
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item dropdown">
                                    <Link
                                        className="nav-link dropdown-toggle"
                                        to="#"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        Shop <i className="flaticon-down-arrow" />
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <Link className="dropdown-item" to="/Shop">
                                                Shop
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/shop-filter">
                                                Sidebar Shop 01
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/shop-filter2">
                                                Sidebar Shop 02
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/ShopDetails">
                                                Shop Details
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/Shop" title="">
                                        Smartwatches
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/Shop" title="">
                                        Laptops &amp; Computers
                                    </Link>
                                </li>
                                <li className="nav-item dropdown">
                                    <Link
                                        className="nav-link dropdown-toggle"
                                        to="#"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        Blog <i className="flaticon-down-arrow" />
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <Link className="dropdown-item" to="/Blog">
                                                Blog
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/BlogDetails">
                                                Blog Details
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item dropdown">
                                    <Link
                                        className="nav-link dropdown-toggle"
                                        to="#"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        Pages <i className="flaticon-down-arrow" />
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <Link className="dropdown-item" to="/Aboutus">
                                                About Us
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Affiliate">
                                                Affiliate
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Career">
                                                Career
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Faq">
                                                Faq
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Error">
                                                404
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="dropdown-item" to="/Contactus">
                                                Contact Us
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="home-search-six">
                        <form role="search">
                            <input
                                type="text"
                                className="form-control"
                                id="search_one"
                                placeholder="Search"
                            />
                            <Link to="#" title="">
                                <i className="flaticon-search" />
                            </Link>
                        </form>
                    </div>
                    <div className="smallscreen-bottom-bar">
                        <div className="row">
                            <div className="col">
                                <Link to="/" title="">
                                    <i className="flaticon-home" />
                                </Link>
                            </div>
                            <div className="col">
                                <div className="smallscreen-badge">
                                    <Link to="/Wishlist" title="">
                                        <i className="flaticon-love" />{" "}
                                        <span className="icon-badge">11</span>
                                    </Link>
                                </div>
                            </div>
                            <div className="col">
                                <div className="smallscreen-badge">
                                    <Link to="/Cart" title="">
                                        <i className="flaticon-bag" />
                                        <span className="icon-badge">0</span>
                                    </Link>
                                </div>
                            </div>
                            <div className="col">
                                <Link to="#" title="">
                                    <i className="flaticon-avatar" />
                                </Link>
                            </div>
                            <div className="col">
                                <Link to="#" title="">
                                    <i className="flaticon-login" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Smallnav
